import { faSpinner, faBan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
// import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { ReactSelectOption } from "../../Interfaces";
// import { useLazyRemoveUserFromGroupQuery } from "../../../services/thoughtSpotV1";
import { MetadataPermission } from "../../../services/types/thoughtSpot";

interface LiveboardCardProps {
  orgId: number;
  // groupId: string;
  groupName: string;
  liveboardInfo: MetadataPermission[];
  user: ReactSelectOption;
  overrideText?: string;
  // tsAccessToken: string;
  //removalCallback: () => any;
}

interface LiveboardCardState {
  confirmingDeletion: boolean;
  removalConfirmationModaltoggle: boolean;
  deleteGroup: string;
  error: {
    errorFlag: boolean;
    errorMessage: string;
  };
  loading: boolean;
  openMenu: boolean;
}

export const LiveboardCard = (props: LiveboardCardProps) => {
  /*   const [removeUserFromGroupQuery, removeUserFromGroupResult] =
    useLazyRemoveUserFromGroupQuery(); */

  const [state, setState] = useState<LiveboardCardState>({
    confirmingDeletion: false,
    removalConfirmationModaltoggle: false,
    deleteGroup: "",
    error: { errorFlag: false, errorMessage: "" },
    loading: false,
    openMenu: false,
  });
  /* 
  const removeFromGroup = async () => {
    setState({
      ...state,
      loading: true,
      deleteGroup: props.groupName,
      removalConfirmationModaltoggle: !state.removalConfirmationModaltoggle,
    });
    removeUserFromGroupQuery({
      thoughtSpotAccessToken: props.tsAccessToken,
      userId: props.user.value,
      groupId: props.groupId,
    });
  }; */

  /*   useEffect(() => {
    if (
      removeUserFromGroupResult.isSuccess &&
      removeUserFromGroupResult.status === "fulfilled"
    ) {
      setState({ ...state, loading: false });
      props.removalCallback();
    }
  }, [removeUserFromGroupResult]);

  const toggleRemovalConfirmationModal = () => {
    setState({
      ...state,
      deleteGroup: props.groupName,
      removalConfirmationModaltoggle: !state.removalConfirmationModaltoggle,
    });
  }; */

  const listLiveboards = () => {
    let liveboards: JSX.Element[] = [];
    let result: JSX.Element = (
      <div className="card-text">
        <div style={{ fontWeight: "bold" }}>
          Liveboards have not been shared with this group.
        </div>
      </div>
    );
    if (props.liveboardInfo?.length !== 0) {
      props.liveboardInfo!.forEach((element) => {
        liveboards.push(<div>{element.metadata_name}</div>);
      });
      result = (
        <div className="card-text">
          <div style={{ fontWeight: "bold" }}>
            {props.overrideText
              ? props.overrideText
              : "This group can interact with the following boards: "}
          </div>
          <div>{liveboards}</div>
        </div>
      );
    }
    return result;
  };

  return (
    <div>
      {state.loading && (
        <div className="module-loading">
          <FontAwesomeIcon
            icon={faSpinner}
            size="2x"
            spin={true}
            style={{ margin: "0 auto" }}
          />
        </div>
      )}
      {!state.loading && (
        <div className="card my-2">
          <div className="card-body">
            <div
              className="d-flex"
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <h5 className="card-title">
                <button
                  className="btn me-2"
                  onClick={() =>
                    setState({ ...state, openMenu: !state.openMenu })
                  }
                >
                  {state.openMenu ? "X" : "V"}
                </button>
                {props.groupName}
              </h5>
              {/*               <button
                style={{ minWidth: 100 }}
                className="btn"
                onClick={() => toggleRemovalConfirmationModal()}
              >
                <FontAwesomeIcon icon={faBan} className="me-1" />
                Remove User from Group
              </button> */}
            </div>
            <div>
              <div style={{ display: state.openMenu ? "block" : "none" }}>
                {listLiveboards()}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <Modal
        isOpen={state.removalConfirmationModaltoggle}
        toggle={toggleRemovalConfirmationModal}
      >
        <ModalHeader toggle={toggleRemovalConfirmationModal}>
          Delete Group
        </ModalHeader>
        <ModalBody>
          Are you sure you want to remove {props.user.label} from{" "}
          {state.deleteGroup}?
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              removeFromGroup();
            }}
          >
            Yes
          </Button>{" "}
          <Button
            color="secondary"
            onClick={() => toggleRemovalConfirmationModal()}
          >
            No
          </Button>
        </ModalFooter>
      </Modal> */}
    </div>
  );
};
